/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TaskUiElementsResponse = {
    title: string;
    iconType: TaskUiElementsResponse.iconType;
    popupType: string;
};

export namespace TaskUiElementsResponse {

    export enum iconType {
        CLIPBOARD_VIAL = 'clipboard-vial',
        CLIPBOARD_APPLE = 'clipboard-apple',
        STETHOSCOPE = 'stethoscope',
        DOCTOR_CARD = 'doctor-card',
        GRADUATION_HAT = 'graduation-hat',
        MONEY_SHIELD = 'money-shield',
        CARD_PHOTO = 'card-photo',
        FORM = 'form',
        BOWL_OF_HYGIENA = 'bowl-of-hygiena',
        HOME_LABS = 'home-labs',
        ARM = 'arm',
        CCS = 'ccs',
        PHARMD = 'pharmd',
        MD = 'md',
        RD = 'rd',
        PEN = 'pen',
        MEDICATION = 'medication',
        TAPE_MEASURE = 'tape-measure',
        WEIGHT_SCALE = 'weight-scale',
    }


}

